const API_BASE_URL = process.env.REACT_APP_API_URL;

/**
 * Search for cities using the backend API
 * @param {string} query - Search query (city or country name)
 * @returns {Promise<Array>} Array of city objects
 */
export const searchCities = async (query) => {
  if (!query || query.length < 2) return [];
  
  try {
    const response = await fetch(`${API_BASE_URL}/cities/search?q=${encodeURIComponent(query)}`);
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.message || 'Failed to fetch cities');
    }
    
    const data = await response.json();
    return data.results || []; // Extract the results array from the response
  } catch (error) {
    console.error('Error searching cities:', error);
    return [];
  }
}; 